"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMERALD_ICON_ARROW_RIGHT = exports.EMERALD_ICON_ARROW_DROP_DOWN = exports.EMERALD_ICON_INPUT_CLEAR = exports.DEFAULT_FONT_SIZE_IN_REM = exports.ELLIPSIS_TEXT = exports.DEFAULT_TRUNCATED_TEXT_LENGTH = exports.EMPTY_STRING = void 0;
/* eslint-disable @typescript-eslint/no-inferrable-types */
exports.EMPTY_STRING = '';
exports.DEFAULT_TRUNCATED_TEXT_LENGTH = 20;
exports.ELLIPSIS_TEXT = '...';
exports.DEFAULT_FONT_SIZE_IN_REM = 1;
/* Emerald icons */
exports.EMERALD_ICON_INPUT_CLEAR = 'input-clear-icon';
exports.EMERALD_ICON_ARROW_DROP_DOWN = 'arrow_drop_down';
exports.EMERALD_ICON_ARROW_RIGHT = 'arrow_right';
//# sourceMappingURL=autocomplete.constants.js.map